import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { useContext } from "react";
import useLeadInfo from "../lead-info.hook";

const useArchiveLead = () => {
  const { lead } = useContext(LeadPageContext);

  const { handleConfirmUpdate, isLoading, isError, isSuccess } = useLeadInfo();

  const handleArchiveLead = () => {
    handleConfirmUpdate({
      lead: {
        archived: lead?.data?.lead?.archived === true ? false : true,
      },
    });
  };

  return {
    isLoading,
    handleArchiveLead,
    isError,
    isSuccess,
  };
};

export default useArchiveLead;
